module.exports = __webpack_public_path__ + "img/signature.671975dc.png";